import styled from 'styled-components';
import { BodyLong01 } from 'components/styles';

export const SubTitle = styled.h5<{ $noMargin?: boolean }>`
  ${BodyLong01};
  margin-bottom: ${({ $noMargin }) =>
    $noMargin ? '0px' : 'var(--spacing-03)'};
`;

export const SubCategoryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-05);
  padding-left: var(--spacing-04);
`;
